var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.851,19.7A9.851,9.851,0,1,0,0,9.851,9.851,9.851,0,0,0,9.851,19.7ZM11,8.112l-2.819.354-.1.468.554.1c.362.086.433.217.355.577l-.908,4.27c-.239,1.1.129,1.624.995,1.624a2.55,2.55,0,0,0,1.8-.736l.108-.512a1.364,1.364,0,0,1-.845.3c-.339,0-.462-.238-.374-.656ZM9.851,6.772A1.231,1.231,0,1,0,8.619,5.541,1.231,1.231,0,0,0,9.851,6.772Z","fill":"currentColor","fillRule":"evenodd"}));
}

Info.defaultProps = {"width":"19.701","height":"19.701","viewBox":"0 0 19.701 19.701"};

module.exports = Info;

Info.default = Info;
